import { isBefore, isAfter, isEqual, isWithinInterval, differenceInMinutes } from 'date-fns';
import isNil from 'lodash/isNil';
import { OPENING_SOON_STATUS, OPEN_STATUS, CLOSING_SOON_STATUS, CLOSED_STATUS } from './CurrentlyOpenLabel.constants';
import { OPENING_SOON_MINUTE_THRESHOLD, CLOSING_SOON_MINUTE_THRESHOLD } from './HoursOfOperation.constants';
import { hourOfOperationToOpenAndCloseDate } from './HoursOfOperation.utils';
export function getAllHourStatus(hours, now, timezone) {
  return hours.map(function (hour) {
    var open = hour.open,
      close = hour.close;
    if (isNil(open) || isNil(close)) {
      return null;
    }
    var _hourOfOperationToOpe = hourOfOperationToOpenAndCloseDate(hour, timezone),
      openMoment = _hourOfOperationToOpe.openMoment,
      closeMoment = _hourOfOperationToOpe.closeMoment;
    var hourStatus = CLOSED_STATUS;
    if (isBefore(closeMoment, openMoment) || isEqual(openMoment, closeMoment)) {
      // Handle ranges that span over midnight
      if (isAfter(now, openMoment)) {
        hourStatus = OPEN_STATUS;
      }
    } else if (isWithinInterval(now, {
      start: openMoment,
      end: closeMoment
    }) && isBefore(now, closeMoment)) {
      // Normal range check using an inclusive start time and exclusive end time
      hourStatus = OPEN_STATUS;
      if (differenceInMinutes(closeMoment, now) <= CLOSING_SOON_MINUTE_THRESHOLD) {
        hourStatus = CLOSING_SOON_STATUS;
      }
    } else {
      var openingSoonDifference = differenceInMinutes(openMoment, now);
      if (openingSoonDifference >= 0 && openingSoonDifference <= OPENING_SOON_MINUTE_THRESHOLD) {
        hourStatus = OPENING_SOON_STATUS;
      }
    }
    return hourStatus;
  });
}